"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _draftJs = require("draft-js");

var _modifyBlockForContentState = _interopRequireDefault(require("draft-js/lib/modifyBlockForContentState"));

var modifyBlock = function modifyBlock(editorState, blockData) {
  var content = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var newContent = (0, _modifyBlockForContentState["default"])(content, selection, function (block) {
    return block.merge(blockData);
  });
  return _draftJs.EditorState.push(editorState, newContent, 'split-block' // TODO: will this do ?
  );
};

var _default = modifyBlock;
exports["default"] = _default;